var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main"},_vm._l((_vm.comData),function(item,index){return _c(item.moduleCode,{key:item.moduleCode + index,tag:"component",attrs:{"homeData":_vm.homeData}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }